import React, { useState } from 'react'

import { sortByQuestionStatus } from 'utils/sorters'
import { DialogConfirm } from 'components'
import NotFoundMessage from 'components/NotFoundMessage'

import { useSelector } from 'react-redux'
import jwtDecode from 'jwt-decode'
import QuestionItem from '../QuestionItem'

import styles from './styles'
import RenderContent from './RenderContent'

const AutomaticQuestions = (props) => {
  const token = useSelector((state) => state.auth.access_token)
  const { role } = jwtDecode(token).extras

  const classes = styles()
  const questions = sortByQuestionStatus(props.questions)

  const [open, setOpen] = useState(false)
  const [currentQuestion, setCurrentQuestion] = useState(null)

  const handleOpenQuestion = (question) => {
    setCurrentQuestion(question)
    setOpen(true)
  }

  const handleClose = () => {
    setCurrentQuestion(null)
    setOpen(false)
  }

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <h2>Perguntas Automáticas</h2>
      </header>
      <p>
        {role === 'Prospect'
          ? 'As perguntas automáticas são geradas pelo sistema ao identificar pontos de interesse nas respostas dadas no formulário.'
          : 'As perguntas automáticas são geradas pelo sistema quando o Background Check encontra divergências nas respostas dadas pelo assessor no formulário.'}
      </p>
      <br></br>
      <div className={classes.questionsContainer}>
        {questions.length > 0 ? (
          questions.map((question) => (
            <QuestionItem
              key={question.uuid}
              question={question}
              action={() => handleOpenQuestion(question)}
            />
          ))
          
        ) : 
          <NotFoundMessage message='Nenhuma pergunta automatica encontrada'/>
        }
      </div>
      {currentQuestion && open ? (
        <DialogConfirm open={open} onCancel={handleClose} btnCancelText="Fechar" maxWidth="custom">
          <RenderContent questionData={currentQuestion} />
        </DialogConfirm>
      ) : null}
    </div>
  )
}

export default AutomaticQuestions
